import axios from "axios";
import { API } from "@/lib/api";

const scout = axios.create({ baseURL: `${API}/scout`, withCredentials: true });

const data = (p) => p.then((r) => r.data);

export const scoutLogin = (passphrase) => data(scout.post("/login", { passphrase }));
export const scoutLogout = () => data(scout.post("/logout"));
export const scoutMe = () => data(scout.get("/me"));
export const scoutSchedule = () => data(scout.get("/schedule"));
export const getEthos = () => data(scout.get("/ethos"));
export const saveEthos = (value) => data(scout.put("/ethos", { value }));
export const startRun = (brief, emailDigest) =>
  data(scout.post("/run", { brief, email_digest: emailDigest }));
export const listRuns = () => data(scout.get("/runs"));
export const getRun = (id) => data(scout.get(`/runs/${id}`));
export const listCandidates = (params = {}) => data(scout.get("/candidates", { params }));
export const patchCandidate = (id, body) => data(scout.patch(`/candidates/${id}`, body));
export const deleteCandidate = (id) => data(scout.delete(`/candidates/${id}`));
export const draftOutreach = (id) => data(scout.post(`/candidates/${id}/outreach`));
export const findSocials = (id) => data(scout.post(`/candidates/${id}/socials`));
export const generateTagPosts = (id) => data(scout.post(`/candidates/${id}/tagposts`));
export const generatePrep = (id) => data(scout.post(`/candidates/${id}/prep`));
export const getCandidate = (id) => data(scout.get(`/candidates/${id}`));
export const getBalance = () => data(scout.get("/balance"));
export const generateMissingTagPosts = () => data(scout.post("/tagposts/generate-missing"));
export const rotationPreview = () => data(scout.get("/rotation/preview"));
export const trendingHooks = () => data(scout.get("/posts/hooks"));
export const latestTrending = () => data(scout.get("/trending/latest"));
export const sendTrending = () => data(scout.post("/trending/send"));
export const recapPreview = () => data(scout.get("/recap/preview"));
export const sendRecap = () => data(scout.post("/recap/send"));
export const sendRotationPosts = () => data(scout.post("/posts/send"));
export const voiceCardUrl = (id, style) => `${API}/voices/${id}/card.png${style ? `?style=${style}` : ""}`;
export const latestDigest = () => data(scout.get("/digests/latest"));
export const sendReminders = () => data(scout.post("/reminders/send"));
export const listQuestions = () => data(scout.get("/questions"));
export const scoutActivity = (since) => data(scout.get("/activity", { params: { since } }));
export const patchQuestion = (id, handled) => data(scout.patch(`/questions/${id}`, { handled }));
export const questionToPrep = (id) => data(scout.post(`/questions/${id}/to-prep`));
export const suggestCandidate = (body) => data(scout.post("/candidates", body));
export const researchCandidate = (id) => data(scout.post(`/candidates/${id}/research`));
export const getAllowlist = () => data(scout.get("/allowlist"));
export const addAllowlist = (email) => data(scout.post("/allowlist", { email }));
export const removeAllowlist = (email) => data(scout.delete(`/allowlist/${encodeURIComponent(email)}`));
export const sendListenerReminders = () => data(scout.post("/listener-reminders/send"));
export const downloadCsv = async () => {
  const res = await scout.get("/candidates.csv", { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `ATFQ-guest-crm-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const STATUSES = ["new", "shortlisted", "contacted", "booked", "passed"];
